// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__wDEK3","row":"Node_row__2dTjN","label":"Node_label__1ogfS","footer":"Node_footer__3RDJj"};